import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BusinessPromoThreeImagesBlockData from 'app/Models/Content/BusinessPromoThreeImagesBlockData';
import React from 'react';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import {getImageProps} from 'app/utilities/ImageProps';

const BusinessPromoThreeImagesBlock = ({data, context}: ComponentProps<BusinessPromoThreeImagesBlockData>) => {
  const {ref, fadeClass} = useFadeIn();
  return (
    <div ref={ref} className={`BusinessPromoThreeImagesBlock ${fadeClass}`}>
      <Image className='BusinessPromoThreeImagesBlock__picture' {...getImageProps(data.image, context)} />

      <div className='BusinessPromoThreeImagesBlock__content'>
        <h3 className='BusinessPromoThreeImagesBlock__content__title'>{data.title.value}</h3>

        <p className='BusinessPromoThreeImagesBlock__content__description'>{data.description.value}</p>

        <div className='BusinessPromoThreeImagesBlock__content__link'>
          <a className='BusinessPromoThreeImagesBlock__content__link__button' href={data.buttonLink.value}>
            {data.buttonLinkTitle.value} &#187;
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessPromoThreeImagesBlock;
